import { version } from '../../package.json';
import { EnvironmentConfig } from 'src/environments/environment-config';

export const environment: EnvironmentConfig = {
    appVersion: version,
    production: false,
    apiBaseUrl: 'https://europe-west3-pacta-sign-dev.cloudfunctions.net', // TODO(PC-4179): stale Cloud Functions URL; replace with the deployed dev API gateway host once available.
};